/* Key value drawings that need a calculation, for the product page and the spec sheet: the light colour spectrum with
   a mark for each colour temperature (the chosen one lit), the beam cone at the real angle, and the lumen scale.
   LuzKV.init(scope) draws them all and returns a function that lights the colour temperature of a chosen version. */
window.LuzKV = (() => {
  /* Colour of a black body at a temperature in kelvin, close enough for display. */
  const k2rgb = (k) => {
    const t = k / 100;
    const r = t <= 66 ? 255 : 329.698727446 * Math.pow(t - 60, -0.1332047592);
    const g = t <= 66 ? 99.4708025861 * Math.log(t) - 161.1195681661 : 288.1221695283 * Math.pow(t - 60, -0.0755148492);
    const b = t >= 66 ? 255 : t <= 19 ? 0 : 138.5177312231 * Math.log(t - 10) - 305.0447927307;
    const c = (v) => Math.round(Math.min(255, Math.max(0, v)));
    return `rgb(${c(r)},${c(g)},${c(b)})`;
  };
  const MIN = 1800, MAX = 9000;
  const pct = (k) => ((k - MIN) / (MAX - MIN)) * 100;
  /* The names the product texts use (request 24): 2200K very warm, 2700K extra warm, 3000K warm, 4000K neutral, 6500K cool. */
  const tone = (k) => (k < 2500 ? "Very warm white" : k < 2850 ? "Extra warm white" : k < 3300 ? "Warm white" : k < 4600 ? "Neutral white" : "Cool white");

  /* Light colour: the spectrum with a mark for each colour temperature of this product; the chosen
     version's one is lit. Shows the colour, nothing to drag. */
  const cct = (cctCard) => {
    const ks = (cctCard.dataset.ks || "").split(",").filter(Boolean).map(Number);
    const sel = cctCard.dataset.sel === "1";
    const bar = cctCard.querySelector("[data-lp-bar]");
    const v = cctCard.querySelector("[data-lp-cct-v]");
    const n = cctCard.querySelector("[data-lp-cct-n]");
    const glow = cctCard.querySelector(".lp-glow");
    const stops = [];
    for (let k = MIN; k <= MAX; k += 300) stops.push(`${k2rgb(k)} ${pct(k).toFixed(1)}%`);
    bar.style.background = `linear-gradient(90deg, ${stops.join(",")})`;
    const marks = ks.map((k) => {
      const m = document.createElement("i");
      m.style.left = pct(k) + "%";
      m.style.setProperty("--c", k2rgb(k));
      m.dataset.k = k;
      bar.appendChild(m);
      return m;
    });
    const lit = (k) => marks.forEach((m) => m.classList.toggle("on", !k || +m.dataset.k === k));
    return (cur) => {
      const k = parseInt(cur, 10) || (ks.length === 1 ? ks[0] : 0);
      if (k && !(sel && !cur)) {
        v.textContent = `${k} K`;
        n.textContent = tone(k);
        glow.style.setProperty("--c", k2rgb(k));
        glow.hidden = false;
        lit(k);
      } else {
        v.textContent = ks.length ? ks.map((x) => `${x}`).join(" / ") + " K" : cctCard.dataset.raw;
        n.textContent = sel ? "Selectable colour temperature." : "";  // set on a switch, a remote or an app, by product
        glow.hidden = true;
        lit(0);
      }
    };
  };

  /* Beam cone drawn at the real angle, with the pool of light from a 3 m ceiling. */
  const beam = (el) => {
    const a = +el.dataset.lpBeam;
    const tan = Math.tan((a / 2) * Math.PI / 180);
    const half = Math.min(tan * 36, 58);
    const d = 2 * 3 * tan;
    el.querySelector("svg").innerHTML = `<defs><linearGradient id="lpcg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffcf73" stop-opacity=".95"/><stop offset="1" stop-color="#ffcf73" stop-opacity=".12"/></linearGradient></defs>
      <path d="M60 6 L${(60 - half).toFixed(1)} 40 L${(60 + half).toFixed(1)} 40 Z" fill="url(#lpcg)"/>
      <rect x="53" y="1" width="14" height="6" rx="2" class="lamp"/>
      <line x1="0" y1="42" x2="120" y2="42" class="floor"/>`;
    el.querySelector("[data-lp-beam-note]").textContent = a <= 90 ? `${d.toFixed(1)} m wide pool from 3 m high.` : "Wide spread for general light.";
  };

  /* Light output on a log scale from 10 to 100 000 lm (ticks at 100, 1 000 and 10 000). */
  const lumen = (s) => {
    const lm = parseFloat(s.dataset.lpLm);
    if (lm > 0) s.style.setProperty("--p", `${Math.min(100, Math.max(0, ((Math.log10(lm) - 1) / 4) * 100)).toFixed(1)}%`);
  };

  const init = (scope = document) => {
    scope.querySelectorAll("[data-lp-beam]").forEach(beam);
    scope.querySelectorAll("[data-lp-lm]").forEach(lumen);
    const card = scope.querySelector("[data-lp-cct]");
    const set = card ? cct(card) : () => {};
    set(card?.dataset.cur || "");
    return set;
  };

  return { init };
})();
